export function Flag({ language }) {
  return (
    <svg
      className="flag-icon"
      width="26"
      height="18"
      viewBox="0 0 26 18"
      aria-hidden="true"
    >
      {language === "en" ? (
        <>
          <path fill="#fff" d="M0 0h26v18H0z" />
          {Array.from({ length: 7 }, (_, i) => (
            <path
              key={i}
              fill="#b22234"
              d={`M0 ${(i * 36) / 13}h26v${18 / 13}H0z`}
            />
          ))}
          <path fill="#3c3b6e" d="M0 0h11v9.7H0z" />
          {Array.from({ length: 9 }, (_, row) =>
            Array.from({ length: row % 2 ? 5 : 6 }, (_, col) => (
              <path
                key={`${row}-${col}`}
                fill="#fff"
                transform={`translate(${0.9 + col * 1.85 + (row % 2 ? 0.9 : 0)} ${0.65 + row * 1.04}) scale(.45)`}
                d="M0-1 .3-.3 1-.3 .45.2 .65.9 0 .5-.65.9-.45.2-1-.3-.3-.3Z"
              />
            )),
          )}
        </>
      ) : language === "pt" ? (
        <>
          <path fill="#009739" d="M0 0h26v18H0z" />
          <path fill="#ffdf00" d="m13 2 11 7-11 7L2 9z" />
          <circle cx="13" cy="9" r="4.5" fill="#002776" />
          <path
            d="M8.7 7.7c3.3-.7 6.2.5 8.4 2.8"
            fill="none"
            stroke="#fff"
            strokeWidth=".85"
          />
          <circle cx="12" cy="10.5" r=".3" fill="#fff" />
          <circle cx="14" cy="12" r=".3" fill="#fff" />
        </>
      ) : (
        <>
          <path fill="#aa151b" d="M0 0h26v18H0z" />
          <path fill="#f1bf00" d="M0 4.5h26v9H0z" />
          <path fill="#aa151b" d="M7 7h4v4a2 2 0 0 1-4 0Z" />
          <path fill="#f1bf00" d="M8 7h2v2H8zM8 10h2v2H8z" />
          <path stroke="#fff" strokeWidth=".7" d="M5.5 7v5m7-5v5" />
          <path fill="#aa151b" d="m7 6 1-1 1 1 1-1 1 1v.7H7z" />
        </>
      )}
    </svg>
  );
}

export function SocialIcon({ name }) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="none"
    >
      {name === "Instagram" && (
        <>
          <rect
            x="3"
            y="3"
            width="18"
            height="18"
            rx="5"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="12"
            cy="12"
            r="4"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" />
        </>
      )}
      {name === "X" && (
        <path
          d="M4 3h4.6L20 21h-4.6L4 3Zm16 0L4 21"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      )}
      {name === "LinkedIn" && (
        <>
          <rect x="2" y="2" width="20" height="20" rx="2" fill="currentColor" />
          <path
            d="M6 10v8m5 0v-8m0 3c0-4 6-4 6 0v5"
            stroke="#fff"
            strokeWidth="2"
          />
          <circle cx="6" cy="6.5" r="1.2" fill="#fff" />
        </>
      )}
      {name === "YouTube" && (
        <>
          <rect x="2" y="5" width="20" height="14" rx="4" fill="currentColor" />
          <path d="m10 9 6 3-6 3z" fill="#fff" />
        </>
      )}
    </svg>
  );
}
